module.exports = __webpack_public_path__ + "static/campus-c8bb66596422df2ad41c9e3cd95dfe04.jpg";